<template>
    <div>
        <b-modal
            :id="modalId"
            @hidden="onModalHidden()"
            modal-class="modal-product-list"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-base-close" @click="hide()">
                        <img src="@/assets/icon/otp_icon_close@3x.png" />
                    </div>
                    <p>{{lbl.qrcode.product_detail.title}}</p>
                </div>
                <div class="modal-base-body">
                    <div class="text-title text-center text-bold">
                        {{name}}
                    </div>
                    <div class="text-description text-center ">
                        {{detail}}
                    </div>
                    <div class="line-section"></div>
                    <div class="receive-point text-center">
                        <span class="mr-2">{{lbl.qrcode.product_detail.text_point}}</span>
                        <span class="mr-2 point text-bold">{{point | number_format}}</span>
                        <span>
                            <img src="@/assets/icon/reward_icon_coin@3x.png" />
                        </span>
                    </div>
                    <div class="line-section"></div>
                    <div class="area-input">
                        <DropdownShop
                            inputId="serviceType"
                            :inputLbl="localePage.buyFrom"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="true"
                            :itemList="listItem"
                            :errorInfo="errorInfo[0]"
                            v-model="content"
                            @input="onTypeChange($event)"
                        ></DropdownShop>
                        <TextInput
                            inputId="shopEarn"
                            :inputLbl="localePage.shopEarn"
                            :isFirstSave="isFirstSave"
                            :isShowErrorLbl="true"
                            :isTextOnly="false"
                            :isRequired="false"
                            :errorInfo="errorInfo[1]"
                            v-model="shopName"
                            v-if="isShowTextbox" />
                    </div>
                </div>
                <div class="modal-base-footer">
                    <div class="btn-ok" @click="clickOk()">
                        <div class="btn-txt">
                            {{lbl.qrcode.product_detail.btn_confirm}}
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
// helper
import FormHelper from "@/helper/FormHelper.js";
import Util from "@/helper/Utility.js";
// component
import DropdownShop from "@/components/Input/DropdownShop.vue";
import TextInput from "@/components/Input/Text.vue";
// mixins
import ErrorApiMixin from "@/mixin/ErrorApiMixin";
import LocaleMixin from "@/mixin/LocaleMixin.js";
// service
import Service from "@/core/Blob/BlobService";
/**
 * @property {ProductDescriptionModalController} controller (required)../Controller/ProductDescriptionModalController.js
 * @property {String} modalId (reqquired)
 */

export default {
    name: "ProductDescriptionModal",
    props: {
        controller: Object,
        modalId: String,
        loadingModal: Object, //loding modal from master controller
        alertModal: Object
    },
    components: {
        DropdownShop,
        TextInput
    },
    mixins: [LocaleMixin, ErrorApiMixin],
    data: function() {
        return {
            title: "",
            message: "",
            btnOk: "",
            tag: "",
            name: "",
            detail: "",
            point: 0,
            busModal: null,
            localePage: {},
            isFirstSave: true,
            errorInfo: [],
            listItem: [],

            content: null,
            shopName: '',
            isShowTextbox: false,
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(2);
        this.busModal = this.controller.busModal;
        this.localePage = this.lbl.modalProductList;
    },
    mounted: function() {
        this.busModal.$on("show", this.show);
        this.busModal.$on("hide", this.hide);
    },
    methods: {
        initialData: function() {
            var appName = "bioderma";
            var path = "scanQRCode/store.json";
            console.log("this.loadingModal", this.loadingModal);
            this.loadingModal.show();
            Service.apiGetBlobByAppNameAndPath(appName, path).subscribe(
                res => {
                    this.listItem = res;
                    this.loadingModal.hide();
                    this.$bvModal.show(this.modalId);
                },
                err => {
                    this.loadingModal.hide();
                    this.errorApi(err);
                }
            );
        },
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function() {
            console.log('change', this.content);

            if(this.isShowTextbox){
                if(this.errorInfo[0].isValid && this.errorInfo[1].isValid){ 
                    this.controller.sendCallbackOk({
                        tag: this.tag,
                        data: this.content,
                        shop: this.shopName,
                    });
                    this.hide();
                } 
            }else{
                if(this.errorInfo[0].isValid){ 
                    this.controller.sendCallbackOk({
                        tag: this.tag,
                        data: this.content,
                        shop: this.shopName,
                    });
                    this.hide();
                } 
            }
            
            this.isFirstSave = false;
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.name = config.name;
            this.detail = config.detail;
            this.point = config.point;
            this.content = "";
            this.shopName = "";
            this.isFirstSave = true;
            this.isShowTextbox = false;
            this.errorInfo[0].msg = "";
            this.errorInfo[1].msg = "";

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }
            this.initialData();
        },
        hide: function() {
            this.content = "";
            this.isFirstSave = true;
            this.$bvModal.hide(this.modalId);
        },
        onTypeChange: function(data){
            this.content = data.value;

            if(data.flag){
                this.isShowTextbox = true;
            }else{
                this.isShowTextbox = false;
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseText.scss";
@import "@/style/input/BaseButton.scss";
@import "../style/ProductDescriptionModal.scss";
</style>

<style lang="scss">
@import "@/style/base/base.scss";
@import "@/style/modal.scss";

.modal-product-list {
    @extend %modal-base;
    color: $bright-gray;
    font-size: 1rem;
    .modal-body {
        padding: 25px;
    }
    .modal-dialog {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        margin: 0;
        .modal-content {
            box-shadow: $box-shadow-bar;
            border-radius: 0;
            border-top-left-radius: 30px;
            border-top-right-radius: 30px;
            border: 0;
            .modal-base-head {
                color: $bright-gray;
                font-size: 1.2rem;
                margin-left: 10px;
                padding-left: 15px;
                letter-spacing: 1.1px;
                &::before {
                    content: " ";
                    position: absolute;
                    left: 0;
                    top: 4px;
                    width: 4px;
                    height: 20px;
                    background: $pink;
                }
                .modal-base-close {
                    position: absolute;
                    top: -5px;
                    right: 0;
                    img {
                        width: 15px;
                    }
                }
            }
        }
        .area-input {
            .wrap-input {
                margin-top: 10px;
                .label {
                    margin-bottom: 5px;

                    &.error{
                        color: unset;
                    }
                }
                .ddl-input {
                    .btn-ddl-input {
                        margin-top: unset;
                        color: $bg-dark;
                    }
                }
                .error-text{
                    text-align: center;
                    padding-top: 5px;
                }
                .input-box{
                    .error.input-field{
                        border-color: unset;
                    }
                }
            }

            .input-box-error {
                .ddl-input {
                    width: 100%;
                    .btn-ddl-input {
                        background-image: url('../../../../assets/icon/dropdown_icon.svg');
                        color: $bright-gray;
                        border: 1px solid $light-gray;
                    }
                }
            }
        }
    }
}
</style>
